import { useEffect, useState } from "react";
import ModalVideo from "react-modal-video";
import Slider from "react-slick";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const HomeSlider = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  const openModal = () => setIsOpen(!isOpen);

  // Fetch banners when component is mounted
  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/banner`);
      if (response.status === 200) {
        setBanner(response?.data?.data);
      }
    } catch (err) {
      console.error(err.response);
    } finally {
      setLoading(false);  // Ensure loading is set to false when done
    }
  };

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    margin: 0,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="react-slider-part">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="SHrbt_s_Nvs"
        onClose={openModal}
      />
     {
      !loading && (
        <div className="home-sliders home2">
        {  (
          <Slider {...sliderSettings}>
            {banner.map((item, index) => (
              <div className="single-slide" key={index}>
                <div className="slider-img">
                  <img
                    className="desktop"
                    crossorigin="anonymous"
                    src={`https://back.yourfrenchteachers.com/${item.coverDesktop}`}
                    alt=''
                  />
                  <img
                    className="mobile home__mobile"
                    crossorigin="anonymous"
                    src={`https://back.yourfrenchteachers.com/${item.coverMobile}`}
                    alt=""
                  />
                </div>
                <div className="container">
                  <div className="slider-content">
                    <div className="content-part">
                      <span
                        className="slider-pretitle wow animate__fadeInUp"
                        data-wow-duration="1s"
                      >
                        {item.text}
                      </span>
                      <h2
                        className="slider-title wow animate__fadeInUp"
                        data-wow-duration="1s"
                      >
                        YOUR FRENCH <br /> TEACHERS
                      </h2>
                      <div
                        className="slider-btn wow animate__fadeInUp"
                        data-wow-duration="1.2s"
                      >
                        {/* Optional links */}
                        <a
                          href="https://apps.apple.com/us/app/your-french-teachers/id6742703203"
                           target="_blank"
                          className="btn btn-dark btn-lg px-3 py-2 me-3 me-sm-3 me-lg-4 mb-3"
                        >
                          <img
                            src="./appstore-light.svg"
                            className="light-mode-img"
                            width={124}
                            alt="App Store"
                          />
                        </a>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.khinezin.yftapp"
                           target="_blank"
                          className="btn btn-dark btn-lg px-3 py-2 mb-3"
                        >
                          <img
                            src="./googleplay-light.svg"
                            className="light-mode-img"
                            width={139}
                            alt="Google Play"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
      )
     }
    </div>
  );
};

export default HomeSlider;
